import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';
import { Role } from '../model/role';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SysadminGuard implements CanActivate {


  constructor(private apiService: ApiService, private router: Router) {}


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const loggedInUser = window.localStorage.getItem('loggedInUser');
    
    // If loggedInUser is not found, return false immediately
    if (!loggedInUser) {
      return false;
    }
  
    // Return an observable that resolves after the API call
    return this.apiService.getEmplyeeDetailsById(loggedInUser).pipe(
      map((data) => {
        let roles = data.roles.map((role: Role) => role.roleName);
        
        // Check if the user is sysadmin
        if (roles.includes("sysadmin")) {
          sessionStorage.setItem("issysadmin", "true");
          return true; // User is sysadmin
        } else {
          sessionStorage.setItem("issysadmin", "false");
          return false; // User is not sysadmin
        }
      }),
      catchError(() => {
        // Handle any errors (e.g., API call fails)
        sessionStorage.setItem("issysadmin", "false");
        return of(false); // Return false in case of error
      })
    );
  }
  
  
}
